import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import CrApp from '../reducers';
import logger from 'redux-logger'

export default function configureStore(initialState) {
    return createStore(CrApp, initialState, applyMiddleware(thunk,logger));
}
